import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=789bf875"
import script from "./DocumentItem.vue?vue&type=script&lang=ts"
export * from "./DocumentItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789bf875')) {
      api.createRecord('789bf875', component.options)
    } else {
      api.reload('789bf875', component.options)
    }
    module.hot.accept("./DocumentItem.vue?vue&type=template&id=789bf875", function () {
      api.rerender('789bf875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentItem.vue"
export default component.exports